export default "__VITE_ASSET__BzcwD2$I__"